module.exports = __webpack_public_path__ + "images/78d155f4b51fa92f0b6e57eb681f9d13-bird.jpg";